import { PaperGenMethodEnum } from "../../common";
import { QuestionReqModel } from "./question-req-model";
import { SetAndQuestionMappingsModel } from "./set-and-section-mappings";

export class CreateQuestionPaperReq {
    qnpModelId: number;
    qnos: string;
    subject: number;
    noOfSets: number;
    generateOtherLanguagePapers: boolean;
    paperBundlerId?: string;
    sectionQuestionMappings: SetAndQuestionMappingsModel[];
    generationMethod: PaperGenMethodEnum;
    userId?: number;
    constructor(qnpModelId: number, subject: number, noOfSets: number, sectionQuestionMappings: SetAndQuestionMappingsModel[], qnos: string, generateOtherLanguagePapers: boolean, generationMethod: PaperGenMethodEnum, paperBundlerId?: string,userId?: number) {
        this.qnpModelId = qnpModelId;
        this.sectionQuestionMappings = sectionQuestionMappings;
        this.qnos = qnos;
        this.subject = subject;
        this.noOfSets = noOfSets;
        this.generateOtherLanguagePapers = generateOtherLanguagePapers;
        this.paperBundlerId = paperBundlerId;
        this.generationMethod = generationMethod;
        this.userId = userId;
    }
}